module.exports = __webpack_public_path__ + "img/avatar0.4f023092.png";